import React, { useState, useEffect } from 'react'
import './AEPHistory.css'
import { store } from '../../../stores/store';
import {FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaAngleDoubleLeft} from 'react-icons/fa'
import Aep from '../../Aep/Aep'
import AepsPool from '../../../js/AepsPool';

function compare2(now, prevYear) {
  return now.filter(x => !prevYear.includes(x))
 }

 const AEPHistory = () => {
  let [changedAeps, setChangedAeps] = useState([])
  let [selectedTurn, setSelectedTurn] = useState(null)



  useEffect(()=> {
    let allChosenActions = store.allChosenAepIds

    let diffs = allChosenActions.map((aeps, index) => {
      if(index === 0) {
        return aeps
      } else {
        return compare2(aeps, allChosenActions[index-1])
      }
    })

    setChangedAeps(diffs)
    setSelectedTurn(diffs.length - 1)
  }, [])


  function first() { setSelectedTurn(0) }
  function prev() { setSelectedTurn(selectedTurn - 1) }
  function next() { setSelectedTurn(selectedTurn + 1) }
  function last() { setSelectedTurn(changedAeps.length - 1) }

  return (
    <div className="AEPHistory">


      {selectedTurn !== null && <div className="col-title">
        <button className="prevnext" disabled={selectedTurn === 0} onClick={first}><FaAngleDoubleLeft /></button>
        <button className="prevnext" disabled={selectedTurn === 0} onClick={prev}><FaAngleLeft /></button>

        { selectedTurn === 0 && <h3>{store.t('initial_practices')}</h3>}
        { selectedTurn > 0   && <h3>{store.t('new_practices_year_n')} {selectedTurn}</h3>}

        <button disabled={selectedTurn === changedAeps.length - 1} className="prevnext" onClick={next}><FaAngleRight /></button>
        <button disabled={selectedTurn === changedAeps.length - 1} className="prevnext" onClick={last}><FaAngleDoubleRight /></button>
      </div>}

      {selectedTurn !== null &&
      (changedAeps[selectedTurn].length === 0) && <div className="changed-aep-empty-list">{store.t("no_aep_modified")}</div>}

      {selectedTurn !== null &&
      changedAeps[selectedTurn].length > 0 &&
        <div>
          {changedAeps[selectedTurn].map(aepId => {
            let data = AepsPool.get(aepId)
            return <Aep key={aepId} data={data} />
          })}
        </div>}
    </div>
  );
};

export default AEPHistory;
